export default {
      id: "circle-check-usage",
      viewBox: "0 0 20 20",
      url: "/dist/svg/" + "sprite.svg#circle-check-usage",
      toString: function () {
        return this.url;
      }
    }